var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader1ShapeBBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Asset 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45",
    d: "M1670 899.58c80.36 1.24 161.54-4.74 242.56-16.39l8.4-1.28V0H1v504.58L16.11 495C191.59 384.52 401 338.07 601 406.88c205.35 70.62 360 245.82 545.89 354.67 162.67 95.24 340.8 135.22 523.11 138.03z",
    fill: "#d7dcea"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7b3BhY2l0eTowLjA1O30uY2xzLTJ7ZmlsbDojZDdkY2VhO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQXNzZXRfMyIgZGF0YS1uYW1lPSJBc3NldCAzIiBjbGFzcz0iY2xzLTEiPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggaWQ9IlBhdGhfNDUiIGRhdGEtbmFtZT0iUGF0aCA0NSIgY2xhc3M9ImNscy0yIiBkPSJNMTY3MCw4OTkuNThjODAuMzYsMS4yNCwxNjEuNTQtNC43NCwyNDIuNTYtMTYuMzlsOC40LTEuMjhWMEgxVjUwNC41OEwxNi4xMSw0OTVDMTkxLjU5LDM4NC41Miw0MDEsMzM4LjA3LDYwMSw0MDYuODhjMjA1LjM1LDcwLjYyLDM2MCwyNDUuODIsNTQ1Ljg5LDM1NC42N0MxMzA5LjU2LDg1Ni43OSwxNDg3LjY5LDg5Ni43NywxNjcwLDg5OS41OFoiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgHeader1ShapeBBlue as ReactComponent };